import { createAction, type IAction } from 'store/helper';

export enum ReportBugActionNames {
  DOWNLOAD_DATA = 'FEATURES/REPORT_BUG/DOWNLOAD_DATA',
}

export const ReportBugActions = {
  downloadData: (): IAction => createAction(ReportBugActionNames.DOWNLOAD_DATA),
};
